import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import AdvantagesSection from "../containers/AdvantagesSection";
import HusqvarnaAdvantagesSection from "../containers/HusqvarnaAdvantagesSection";
import SuggestionPresentation from "../containers/SuggestionPresentation";

import Footer from "../containers/Footer";
import AppWrapper from "../containers/AppWrapper";

class Suggestion extends Component {
  constructor(props) {
    super(props);
    this.handleOpen = this.handleOpen.bind(this);
    this.state = {
      isOpen: false
    };
  }
  handleOpen = () => this.setState({ isOpen: true });
  render() {
    return (
      <AppWrapper>
        <TopNav />

        <SuggestionPresentation
          collection={this.props.match.params.collectionId}
          suggestionId={this.props.match.params.suggestionId}
          key={new Date().getTime()}
        />
        {this.props.match.params.suggestionId === "husqvarna" ? <HusqvarnaAdvantagesSection /> : <AdvantagesSection />}
        <Footer />
      </AppWrapper>
    );
  }
}

export default Suggestion;
